import { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import { IoFlash } from 'react-icons/io5';
import { BsWhatsapp, BsFacebook, BsInstagram, BsYoutube, BsTwitterX } from 'react-icons/bs';
import { MdLocationOn, MdPhone, MdEmail, MdAccessTime, MdPerson, MdBusiness, MdMessage, MdCheckCircle } from 'react-icons/md';
import { FiPhone, FiMail, FiUser, FiMapPin, FiClock } from 'react-icons/fi';

export default function Contact() {
  const [form, setForm] = useState({ name:'', email:'', phone:'', service:'', message:'' });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = e => {
    e.preventDefault();
    const phoneNumber = '919316406182';
    const message = `Hello, I have a new enquiry:\n\n👤 Name: ${form.name}\n📞 Phone: ${form.phone}\n📧 Email: ${form.email}\n🛠 Service: ${form.service}\n💬 Message: ${form.message}`;
    window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 5000);
    setForm({ name:'', email:'', phone:'', service:'', message:'' });
  };

  const infoItems = [
    { Icon:FiMapPin, label:'Store Address', value:' ahmedabad gujarat' },
    { Icon:FiPhone,  label:'Phone',         value:'+91 7698334318 ' },
    { Icon:FiMail,   label:'Email',         value:'info@sparkzone.in / sales@sparkzone.in' },
    { Icon:FiClock,  label:'Working Hours', value:'Monday – Saturday: 9:00 AM – 8:00 PM\nSunday: 10:00 AM – 2:00 PM' },
  ];

  return (
    <div className="page-wrapper">

      <section className="page-hero bg-grid">
        <div className="page-hero-inner container">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="breadcrumb-sep">›</span>
            <span>Contact Us</span>
          </div>
          <div className="tag"><span className="tag-dot" />Reach Out</div>
          <h1 className="page-hero-title">CONTACT <span>US</span></h1>
          <p className="page-hero-desc">
            Questions, quotes, or just want to say hello? Our team responds within 2 hours on working days.
          </p>
          <div className="page-hero-line" />
        </div>
        <div className="page-hero-bg-text">CONTACT</div>
      </section>

      {/* Contact section */}
      <section className="section">
        <div className="container">
          <div className="contact-layout">

            {/* Info side */}
            <div className="contact-info animate-fadeInLeft">
              <div>
                <div className="section-subtitle">Get In Touch</div>
                <h2 className="section-title" style={{ marginBottom:12, fontSize:'2.2rem' }}>
                  LET'S <span>TALK</span>
                </h2>
                <p style={{ color:'var(--gray-400)', fontSize:'.95rem', lineHeight:1.75 }}>
                  Whether you need a single LED bulb or a full factory fit-out, we're here to help. Visit our store, call us, or fill the form.
                </p>
              </div>

              {infoItems.map((item, i) => (
                <div className="contact-info-item" key={i} style={{ opacity:0, animation:`fadeInLeft 0.6s ease ${i*0.12}s forwards` }}>
                  <div className="contact-info-icon"><item.Icon /></div>
                  <div>
                    <div className="contact-info-label">{item.label}</div>
                    <div className="contact-info-value" style={{ whiteSpace:'pre-line' }}>{item.value}</div>
                  </div>
                </div>
              ))}

              {/* Social buttons */}
              <div style={{ display:'flex', gap:10, flexWrap:'wrap', opacity:0, animation:'fadeInLeft 0.6s ease 0.5s forwards' }}>
                {[
                  { Icon:BsFacebook,  label:'Facebook',  color:'#1877f2' },
                  { Icon:BsInstagram, label:'Instagram', color:'#e4405f' },
                  { Icon:BsTwitterX,  label:'Twitter',   color:'#1da1f2' },
                  { Icon:BsYoutube,   label:'YouTube',   color:'#ff0000' },
                  { Icon:BsWhatsapp,  label:'WhatsApp',  color:'#25d366' },
                ].map((s, i) => (
                  <button key={i} style={{
                    display:'flex', alignItems:'center', gap:8,
                    padding:'10px 16px',
                    background:'var(--card-bg)', border:'1px solid var(--card-border)',
                    borderRadius:'var(--radius)', color:'var(--gray-200)',
                    fontFamily:"'Rajdhani',sans-serif", fontWeight:600, fontSize:'.88rem',
                    cursor:'pointer', transition:'var(--transition)',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.borderColor=s.color; e.currentTarget.style.color=s.color; e.currentTarget.style.background=`${s.color}15`; }}
                  onMouseLeave={e => { e.currentTarget.style.borderColor='var(--card-border)'; e.currentTarget.style.color='var(--gray-200)'; e.currentTarget.style.background='var(--card-bg)'; }}
                  >
                    <s.Icon style={{ fontSize:'1rem' }} />
                    {s.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Form */}
            <div className="contact-form" style={{ opacity:0, animation:'fadeInRight 0.7s ease 0.2s forwards' }}>
              <h3 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.85rem', letterSpacing:3, marginBottom:6 }}>
                SEND A <span style={{ color:'var(--primary)' }}>MESSAGE</span>
              </h3>
              <p style={{ color:'var(--gray-400)', fontSize:'.88rem', marginBottom:28 }}>
                We'll get back to you within 2 hours on working days.
              </p>

              {submitted && (
                <div style={{
                  background:'rgba(245,166,35,.1)', border:'1px solid rgba(245,166,35,.4)',
                  borderRadius:'var(--radius)', padding:'14px 18px', marginBottom:22,
                  color:'var(--primary)', display:'flex', alignItems:'center', gap:10,
                  fontFamily:"'Rajdhani',sans-serif", fontWeight:600, fontSize:'1rem',
                  animation:'fadeInUp .4s ease forwards',
                }}>
                  <MdCheckCircle style={{ fontSize:'1.3rem' }} />
                  Message sent! Opening WhatsApp…
                </div>
              )}

              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group" style={{ marginBottom:0 }}>
                    <label className="form-label"><FiUser />Full Name *</label>
                    <input className="form-input" type="text" name="name" placeholder="Your full name" value={form.name} onChange={handleChange} required />
                  </div>
                  <div className="form-group" style={{ marginBottom:0 }}>
                    <label className="form-label"><FiPhone />Phone Number</label>
                    <input className="form-input" type="tel" name="phone" placeholder="+91 98765 XXXXX" value={form.phone} onChange={handleChange} />
                  </div>
                </div>

                <div className="form-group">
                  <label className="form-label"><FiMail />Email Address *</label>
                  <input className="form-input" type="email" name="email" placeholder="you@example.com" value={form.email} onChange={handleChange} required />
                </div>

                <div className="form-group">
                  <label className="form-label"><MdBusiness style={{ fontSize:'.85rem' }} />Service / Enquiry Type</label>
                  <select className="form-select" name="service" value={form.service} onChange={handleChange}>
                    <option value="">Select a service…</option>
                    <option>Product Purchase / Enquiry</option>
                    <option>Home Wiring & Rewiring</option>
                    <option>Industrial Electrical Work</option>
                    <option>LED Lighting Solutions</option>
                    <option>Solar Panel Installation</option>
                    <option>Inverter & UPS Service</option>
                    <option>Electrical Safety Audit</option>
                    <option>General Enquiry</option>
                  </select>
                </div>

                <div className="form-group">
                  <label className="form-label"><MdMessage style={{ fontSize:'.85rem' }} />Message *</label>
                  <textarea
                    className="form-textarea" name="message"
                    placeholder="Tell us what you need — product details, site location, budget, timeline…"
                    value={form.message} onChange={handleChange} required
                  />
                </div>

                <button type="submit" className="btn-primary" style={{ width:'100%', justifyContent:'center', padding:'15px' }}>
                  <BsWhatsapp style={{ fontSize:'1.1rem' }} />
                  Submit Enquiry
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map placeholder */}
      <div style={{
        width:'100%', height:'260px',
        background:'linear-gradient(135deg,var(--secondary) 0%,var(--dark-2) 100%)',
        display:'flex', alignItems:'center', justifyContent:'center',
        flexDirection:'column', gap:14,
        borderTop:'1px solid rgba(245,166,35,.1)',
        borderBottom:'1px solid rgba(245,166,35,.1)',
        position:'relative', overflow:'hidden',
      }}>
        <div style={{
          position:'absolute', inset:0,
          backgroundImage:'linear-gradient(rgba(245,166,35,.04) 1px,transparent 1px),linear-gradient(90deg,rgba(245,166,35,.04) 1px,transparent 1px)',
          backgroundSize:'52px 52px',
        }} />
        <MdLocationOn style={{ fontSize:'3rem', color:'var(--primary)', filter:'drop-shadow(0 0 14px var(--primary))', position:'relative', zIndex:2 }} />
        <div style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.5rem', letterSpacing:3, color:'var(--primary)', position:'relative', zIndex:2 }}>
          MANINAGAR, AHMEDABAD
        </div>
        <p style={{ color:'var(--gray-400)', fontSize:'.88rem', position:'relative', zIndex:2, textAlign:'center' }}>
          12, Maninagar Cross Road, Near St. Xavier's School, Ahmedabad – 380008
        </p>
        <a href="https://maps.google.com" target="_blank" rel="noreferrer" className="btn-outline" style={{ marginTop:4, position:'relative', zIndex:2, padding:'10px 22px', fontSize:'.85rem' }}>
          Open in Google Maps <FiPhone style={{ transform:'rotate(90deg)' }} />
        </a>
      </div>

      <Footer />
    </div>
  );
}